




















import { Component, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import { axios } from '@/utils/axios';

@Component({
  components: {
    Modal,
    MainButton,
  },
})
export default class ModalGradePaperSchema extends Vue {
  openModal: any = null;
  closeModal: any = null;

  @Prop({ required: true })
  gradePaperUuid: string;

  mounted() {
    this.$emit('openModalGradePaperConfirmAdd', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }

  async autoGradeConfirm() {
    try {
      const response = await axios.post(
        `/grade-papers/${this.gradePaperUuid}/auto-grade`,
      );

      if (response) {
        this.$sendMpEvent({ event: this.$mp_value.AutoGrade_Start });
        this.$emit('refetchPaperAndAnswerSheets');
        this.closeModal && this.closeModal();
      }
    } catch (error) {
      this.$toasted.global.mainToast({
        message: error,
      });
    }
  }
}
